module.exports = __webpack_public_path__ + "media/iconfont/material-icons-53436aca.woff2";